import { styled } from '@mui/styles';
import Box from '@mui/material/Box';

export const StyledTopPagesTeams = styled(Box)(({ theme }) => ({
    backgroundColor: '#FAFAFA',
    padding: '40px 0',

    '& .TopPagesStack': {
        flexDirection: 'row',
        justifyContent: 'space-around',

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: '40px'
        },

        '& .TopPagesBox': {
            flexBasis: 'calc(33.33333% - 15px)',
            maxWidth: '30%',

            [theme.breakpoints.down('sm')]: {
                maxWidth: 'unset',
            },

            '& .PagesHeader': {
                fontSize: '18px'
            },

            '& .FundraiserCard': {
                flexDirection: 'row',
                gap: '16px',
                marginTop: '15px',

                '& .progress': {
                    margin: 0
                },

                '& .ImageBox': {
                    width: '60px',
                    height: '60px',
                    borderRadius: '5px',
                    border: `0.5px solid ${theme.palette.neutral.light}`,

                    '& img': {
                        objectFit: 'cover',
                        height: '100%',
                        width: '100%',
                        borderRadius: 'inherit'
                    }
                },

                '& .DetailsBox': {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    flexBasis: '80%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',

                    '& .PageTitle': {
                        maxWidth: '100%',
                        fontSize: '16px',

                        '& .MuiTypography-root': {
                            overflow: 'hidden', textOverflow: 'ellipsis'
                        }
                    }
                }
            }
        }
    }
}));
